import generateDefaultHtmlMetadata from '@/config/brandings/default/headerTags.ts'
import { getNativeConfig } from 'src/config/brandings/default/nativeConfig.ts'

module.exports = () => {
  const headerTags = generateDefaultHtmlMetadata()
  return {
    app_name: 'Sdui',
    styles: {
      load: () => import(/* webpackChunkName: "styleDefault" */'src/config/brandings/default/index.scss')
    },
    meta: {
      meta: [
        { name: 'apple-itunes-app', content: headerTags.meta.appleItunesApp },
        { name: 'application-name', content: headerTags.meta.applicationName },
        { name: 'author', content: headerTags.meta.author },
        { name: 'copyright', content: headerTags.meta.copyright },
        { name: 'description', content: headerTags.meta.description },
        { name: 'og:image', content: headerTags.meta.open_graph.image },
        { name: 'og:title', content: headerTags.title },
        { name: 'og:url', content: headerTags.meta.open_graph.url },
        { name: 'og:author', content: headerTags.meta.author },
        { name: 'og:description', content: headerTags.meta.description },
        { name: 'twitter:image', content: headerTags.meta.open_graph.image },
        { name: 'twitter:url', content: headerTags.meta.open_graph.url },
        { name: 'twitter:title', content: headerTags.title },
        { name: 'twitter:description', content: headerTags.meta.description }
      ],
      link: [
        { rel: 'shortcut icon', href: headerTags.link.favIcon },
        { rel: 'copyright', href: headerTags.link.copyrightLink }
      ]
    },
    logos: {
      logo: 'brandings/default/logo/sdui-seven-education-logo.svg'
    },
    search: {
      queries: {
        branding: null
      }
    },
    start: {
      description: 'public.start.security',
      image: 'brandings/default/start/sdui-start-image.jpg',
      show_more: true,
      sdui_authenticator: false
    },
    management: {
      show_announcements: true,
      show_material_page: true,
      additional_content: {
        infos: 'management.additional_content.infos'
      }
    },
    ui: {
      show_hint_cards: true,
      show_video_hint: true
    },
    settings: {
      notifications: {
        email_newsletter: false
      }
    },
    dataProtection: {
      show_go_to_sdui_website: true
    },
    onboarding: {
      help_videos: true
    },
    keepAlivePing: false,
    appSwitcher: {
      show_marketing: true
    },
    login: {
      registration_code: true,
      hideSduiLoginDefault: false,
      sduiLoginDefaultExpanded: false,
      form: {
        inline_reset_password: true
      }
    },
    ...getNativeConfig()
  }
}
